/**
 * @generated SignedSource<<bb585c529bab9cef4749ed2a03ab95a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TabWithMenu_container$data = {
  readonly canEdit?: boolean | null | undefined;
  readonly scopeId?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"TabMenu_container">;
  readonly " $fragmentType": "TabWithMenu_container";
};
export type TabWithMenu_container$key = {
  readonly " $data"?: TabWithMenu_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"TabWithMenu_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "TabWithMenu_container",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TabMenu_container"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canEdit"
        },
        {
          "kind": "ScalarField",
          "name": "scopeId"
        }
      ],
      "type": "JiraContainerNavigation"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "6224b42f30483a79a7b9e5f35d80a3f9";

export default node;
